export let getConfig: () => Promise<Record<string, unknown>>;

export function setGetConfigService(value: typeof getConfig) {
    getConfig = value;
}
